/**
 * src/lib/recuperacion.js — enlace del correo de recuperación de contraseña.
 *
 * Bug 2026-10-23 (usuaria real): el enlace la dejaba en la landing. GoTrue lee
 * redirect_to de la query string de /recover; lo mandábamos en el body
 * (gotrue_meta_security, que es del captcha) y Supabase caía a la Site URL.
 */

/** URL de /auth/v1/recover con el redirect_to donde GoTrue lo busca. */
export function urlRecover(supabaseUrl, redirectTo) {
  const u = new URL('/auth/v1/recover', supabaseUrl);
  if (redirectTo) u.searchParams.set('redirect_to', redirectTo);
  return u.toString();
}

/**
 * Red de seguridad: si Supabase igual redirige a otra página (allowlist de
 * Redirect URLs mal configurada, correo viejo), el hash con el token o con el
 * error del enlace se lleva a /reset-password. Devuelve el destino o null.
 */
export function destinoRecuperacion(pathname, hash) {
  if (!hash || pathname === '/reset-password') return null;
  const p = new URLSearchParams(hash.replace(/^#/, ''));
  const esRecuperacion = p.get('type') === 'recovery' && p.has('access_token');
  const enlaceFallido = p.has('error') && /otp_expired|access_denied/.test(`${p.get('error_code')} ${p.get('error')}`);
  return esRecuperacion || enlaceFallido ? `/reset-password${hash}` : null;
}

const ORIGENES_OFICIALES = new Set(['https://drvictorlegal.com', 'https://www.drvictorlegal.com']);

/**
 * Origin del request que se acepta como destino del enlace, o null (el caller
 * usa getSiteUrl()). Coincidencia exacta: con *.vercel.app o subdominios
 * cualquiera podía pedir la recuperación de otra cuenta con su propio Origin y
 * recibir el token. Los previews no lo necesitan: getSiteUrl() ya devuelve su
 * VERCEL_URL. localhost solo fuera de producción.
 */
export function origenRecuperacion(requestOrigin, env = process.env) {
  if (!requestOrigin) return null;
  let origin;
  try { origin = new URL(requestOrigin).origin; } catch { return null; }
  if (ORIGENES_OFICIALES.has(origin)) return origin;
  if (env.VERCEL_ENV !== 'production' && /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(origin)) return origin;
  return null;
}
